var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoCloseWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 12H19"
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    dur: "0.4s",
    values: "M5 12H19;M12 12H12"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    attributeName: "opacity",
    begin: "0.4s",
    to: 0
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5 5L19 5M5 19L19 19",
    opacity: 0
  }, /*#__PURE__*/React.createElement("animate", {
    fill: "freeze",
    attributeName: "d",
    begin: "0.2s",
    dur: "0.4s",
    values: "M5 5L19 5M5 19L19 19;M5 5L19 19M5 19L19 5"
  }), /*#__PURE__*/React.createElement("set", {
    fill: "freeze",
    attributeName: "opacity",
    begin: "0.2s",
    to: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoCloseWhite);
export default __webpack_public_path__ + "static/media/trvto_closeWhite.69f6a50d97b885e30f5d0ea7a4973087.svg";
export { ForwardRef as ReactComponent };